<template>
  <div class="block">
    <el-cascader
      class="el-cascader"
      :clearable="clearable"
      :size="size"
      :value="officeId"
      ref="officeCascader"
      :disabled="disabled"
      :placeholder="placeholder"
      @change="change"
      :options="options"
      :props="{ checkStrictly: true,expandTrigger: 'hover',label:'name',value:'id',children:'children' }"
      >
    </el-cascader>
  </div>
</template>
<script>
  export default {
    data(){
      return{
        options:[]
      }
    },
    model:{
      prop:'officeId',
      event:'officeIdChange'
    },
    props: {
      size: {
        type: String,
        default: 'medium'
      },
      officeId: {
        type: String,
        default: ''
      },
      code: {
        type: String,
        default: 'root'
      },
      placeholder:{
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      officeId(value){
        this.getOfficeTree();
      }
    },
    mounted() {
      this.getOfficeTree()
    },
    computed:{
    },
    methods:{
      change(array){
        if(array.length>0){
          let pid = this.$refs.officeCascader.getCheckedNodes()[0].value;
          this.$emit('officeIdChange', pid);
        }else{
          this.$emit('officeIdChange', '');
        }
      },
      getOfficeTree() {
        this.$request.doGet('/admin/sysOffice/getOfficeTree?code='+this.code).then(res => {
          if (res.isOk) {
            this.options =res.list[0].children;
          }
        });
      },
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sui-office/sui-office.vue